module.exports = __webpack_public_path__ + "static/pepper-5c29da29f28dc6e847b0ccd0fdaf2a41.svg";